module.exports = __webpack_public_path__ + "static/rcc-most-common-ar-graph-desktop-fb4aac3264ddae76abadcedb50798ed8.png";